(function identityTracker(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Analytics = global.NewHomeSource.Analytics || {};

  const previousIdentityTracker = global.NewHomeSource.Analytics.identityTracker;
  const configurations = {
    hasBeenAttached: false
  };

  /**
   * @private
   * closestForm: finds the closes Form element that contains the given inspectedElement.
   *
   * @param {HTMLNodeElement} inspectedElement which parents are being analyzed.
   */
  function closestForm(inspectedElement) {
    if (inspectedElement.tagName === 'FORM') {
      return inspectedElement;
    }

    if (inspectedElement.parentElement && inspectedElement.parentElement.tagName !== 'BODY') {
      return closestForm(inspectedElement.parentElement);
    }

    return null;
  }

  function inspectEvent(event, target) {
    const inspectedElement = target || event.target;

    if (!inspectedElement || !inspectedElement.dataset || !inspectedElement.dataset.identity || event.button !== 0) {
      if (inspectedElement.parentElement && inspectedElement.parentElement.tagName !== 'BODY') {
        inspectEvent(event, inspectedElement.parentElement);
      }

      return;
    }

    if (event.type === 'mousedown' && inspectedElement.dataset.eventType !== 'mousedown') {
      return;
    }

    const dataset = inspectedElement.dataset;
    const form = closestForm(inspectedElement);

    if (!form || !form.reportValidity()) {
      return;
    }

    const data = {
      caller: inspectedElement.cloneNode(true),
      form: form.cloneNode(true)
    };

    for (let index = 0; index < configurations.totalHandlers; index += 1) {
      const handler = configurations.handlers[index].identityTracker;
      const validator = configurations.handlers[index].identityTrackerValidator;

      if (validator(dataset)) {
        configurations.queue.pushTask(handler.bind(data));
      }
    }

    if (inspectedElement.dataset.eventForget) {
      delete inspectedElement.dataset.event;
    }
  }

  /**
   * @constructs NewHomeSource.Analytics.IdentityTracker;
   *
   * @param {IdleQueue} eventsQueue that runs the tasks on idle periods.
   * @param {Array} handlers that will react to the impression tracking.
   */
  function IdentityTracker(eventsQueue, handlers) {
    configurations.queue = eventsQueue;
    configurations.handlers = [];

    const totalHandlers = handlers.length;

    for (let index = 0; index < totalHandlers; index += 1) {
      if (handlers[index] &&
        typeof handlers[index].identityTracker === 'function' &&
        typeof handlers[index].identityTrackerValidator === 'function') {
        configurations.handlers.push(handlers[index]);
      }
    }

    configurations.totalHandlers = configurations.handlers.length;
  }

  /**
   * @public
   * init: attaches a event listeners to the mousedown and click events.
   */
  IdentityTracker.init = function init() {
    if (configurations.hasBeenAttached) {
      return;
    }

    configurations.hasBeenAttached = true;

    // As in some places of the code developers break the bubbling behavior we listen for both events
    // mousedown and click. Only one of them will be handled, click as default and mousedown
    // when indicated as data attribute.
    document.addEventListener('mousedown', inspectEvent, { composed: true, useCapture: true });
    document.addEventListener('click', inspectEvent, { composed: true, useCapture: true });
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.Analytics.eventTracker to the previous script.
   */
  IdentityTracker.noConflict = function noConflict() {
    global.NewHomeSource.Analytics.identityTracker = previousIdentityTracker;
    return IdentityTracker;
  };

  global.NewHomeSource.Analytics.identityTracker = IdentityTracker;
}(window));
